import { fetchingBadges, fetchedBadges, errorBadges } from '../actions/badges.types';
import { keyBy } from 'lodash';

export default (state = {}, { type, payload } = {}) => {
  switch (type) {
  case fetchingBadges:
    return { ...state, ...{ fetching: true, fetched: false } };
  case fetchedBadges:
    return { ...state, ...{ fetching: false, fetched: true, data: keyBy(payload, '_id') } };
  case errorBadges:
    return { ...state, ...{ fetching: false, fetched: true, error: payload } };
  default:
    return state;
  }
};

